import React, { useEffect, useState } from "react";
import "./AdmitCard.css";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { useNavigate, useLocation } from "react-router-dom";
import setting from "../../setting.json";

// var options = {
//   key: "rzp_live_4doEjSk91kjkBU", // Enter the Key ID generated from the Dashboard
//   amount: parseInt(amount) * 100, // Amount is in currency subunits.
//   currency: "INR",
//   name: "Acharya Chanakya Mahavidyalay",
//   description: "Talent Search Exam Form Fee",
//   order_id: "order_9A33XWu170gUtmorder_9A33XWu170gUtm", // This is a sample Order ID. Pass the `id` obtained in the response of Step 1
//   callback_url: "https://eneqd3r9zrjok.x.pipedream.net/",
//   prefill: {
//     //We recommend using the prefill parameter to auto-fill customer's contact information especially their phone number
//     name: "<name>", //your customer's name
//     email: "<email>",
//     contact: "<phone>", //Provide the customer's phone number for better conversion rates
//   },
// };

// export const PaymentDemo = () => {
//   const handlePay = () => {
//     if (typeof window.Razorpay === "undefined") {
//       alert("Razorpay SDK not loaded");
//       return;
//     }

//     const options = {
//       key: "rzp_test_1DP5mmOlF5G5agrzp_test_1DP5mmOlF5G5ag   rzp_test_DP15mmOlF5G5ag", // test key (Razorpay demo)
//       amount: 50000, // ₹500 (in paise)
//       currency: "INR",
//       name: "Demo College",
//       description: "Application Fee",

//       handler: function (response) {
//         alert("Payment Successful 🎉");
//         console.log(response);
//       },

//       prefill: {
//         name: "Simran",
//         email: "simran@test.com",
//         contact: "9999999999",
//       },

//       theme: {
//         color: "#3399cc",
//       },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };

//   return <button onClick={handlePay}>Pay Now</button>;
// };

function Message() {
  const { id } = useParams();
  console.log(id);

  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState();
  const [amount, setAmount] = useState("");

    const getExamDataByRegno = async (id) => {
      await fetch(
        "https://api.acmcollege.org/online/getExamDataByRegno?regno=" + id,
        {
          method: "GET",
        },
      )
        .then((response) => response.json())
        .then((res) => {
          setUserDetails(res.data);
          console.log(res.data);
        });
  };
  

  useEffect(() => {
      
      getExamDataByRegno(id);

    },[id]);

  const handlePay = () => {
    if (typeof window.Razorpay === "undefined") {
      alert("Razorpay SDK not loaded");
      return;
    }

    const options = {
      key: "rzp_live_4doEjSk91kjkBU", // Enter the Key ID generated from the Dashboard
      amount: parseInt(userDetails.amount) * 100, // Amount is in currency subunits.
      currency: "INR",
       name: "Acharya Chanakya Mahavidyalay",
       description: "Talent Search Exam Form Fee",
       order_id:userDetails.order_id,
     

     handler: function (response) {
        alert("Payment Successful 🎉");
       console.log(response);

       const result = JSON.stringify(response);
       console.log(result);

       savePaymentInfo(result);
      },

      prefill: {
        name: "Acharya Chanakya Mahavidyalay",
        email: "acmv2121@gmail.com",
        contact: "9161666937",
        amount:userDetails.amount
      },

      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };


  const savePaymentInfo = async (result) => {
    console.log(result);
    
  const fd = {
         trans_no: result.razorpay_payment_id,
         amount: userDetails.amount,
         id: userDetails.id
       }
    await fetch("https://api.acmcollege.org/online/savePaymentInfo", {
      
        method: "post",
         headers: {
              "Content-Type": "application/json",
               "Accept": "application/json"
  },
                body: JSON.stringify(fd),

      })
        .then((response) => response.json())
        .then((u) => {
          console.log(u);
          if (u.result == "success") {
        
            navigate("/paymentSuccess")
          } else {
            navigate("/formerror");
          }
        });
    };

  return (
    <>
      <div className="student-page">
        <Header />
        <header className="height-75">
          <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
            <h1 className="text-center fw-semibold">
              {" "}
              Complete Your Registration{" "}
            </h1>
          </div>
        </header>

        <div className="container my-5">
          <div className="row">
            <div className="col-lg-12 d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
              <h2
                className="mb-4 mb-lg-5"
                style={{ alignSelf: "center", marginTop: "20px" }}
              >
                Form Successfully submitted
              </h2>
            </div>

            <Row>
              <div>
                <div className="container">
                  <Row>
                    <Col lg={2}></Col>
                    <Col lg={8}>
                      <Card>
                        <Card.Body>
                          <Table bordered hover>
                            <tbody>
                              <tr>
                                <td>Registration No.</td>
                                <td>
                                  <b style={{ color: "red" }}> {id}</b>
                                </td>
                              </tr>
                              <tr>
                                <td>Application No.</td>
                                <td>{userDetails?.id}</td>
                              </tr>
                              <tr>
                                <td>Name</td>
                                <td>{userDetails?.stu_name}</td>
                              </tr>
                              <tr>
                                <td>Date of Birth</td>
                                <td>{userDetails?.dob}</td>
                              </tr>
                              <tr>
                                <td>Mobile No.</td>
                                <td>{userDetails?.phone}</td>
                              </tr>
                            </tbody>
                          </Table>
                          <h5 className="d-flex justify-content-center mt-4 me-4">
                            Application Fees Rs. 20 /- (Rupees Twenty Only){" "}
                          </h5>
                          <div className="d-flex justify-content-center mt-4 me-4">
                            <Button onClick={handlePay}>Pay Now</Button>
                          </div>{" "}
                          <Card.Link
                            href="/admit-card-2025"
                            className="d-flex justify-content-end mt-4"
                          >
                            Print Admit Card
                          </Card.Link>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={2}></Col>
                  </Row>
                </div>
              </div>
            </Row>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Message;
